import { render } from "./SupportRequestForm.vue?vue&type=template&id=1af101a4&scoped=true"
import script from "./SupportRequestForm.vue?vue&type=script&lang=js"
export * from "./SupportRequestForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./SupportRequestForm.vue?vue&type=style&index=1&id=1af101a4&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af101a4"]])

export default __exports__